import InstaToolInfoPage from "../modules/insta-tools/InstaToolInfoPage";

export default InstaToolInfoPage;
